import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { QuarterSelectorService } from '../services/quarter-selector.service';
import { Organization } from '../types/organization';


@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent implements OnInit {
  public selectedOrg: Organization;
  private orgSubscrption: Subscription;

  constructor(
    private readonly router: Router,
    private readonly selectorService: QuarterSelectorService
  ) { }

  ngOnInit() {
    if (this.selectorService.isInitialized()) {
      this.selectedOrg = this.selectorService.selectedOQContext.org;
      this.determineNavScreen();
    } else {
      this.orgSubscrption = this.selectorService.selectedContextChange.subscribe({
        next: (value) => {
          if (value) {
            this.selectedOrg = value.org;
            this.determineNavScreen();
            this.orgSubscrption.unsubscribe();
          }
        }
      });
    }
  }

  // NG 05/31/22: Always redirect to Data Entry Status as home screen
  determineNavScreen() {
    const dest: string = 'data-entry-status';
    this.navigate(dest);
  }

  navigate(route: string) {
    this.router.navigate([`/${route}`], {
    });
  }

}
